/* ================================================================
   ENTORNO — MOBILE JS  (max-width: 749px only)
   ================================================================ */
(function() {
  'use strict';

  var isMobile = window.matchMedia('(max-width: 749px)').matches;

  /* --------------------------------------------------------
     STORIES carousel: inicia en card 1 (con peek de card 2).
     Snap REVERSIBLE atado a la sección siguiente "Chocolate Display
     Box" (.ent-editorial):
       - Cuando esa sección ENTRA al viewport (usuario bajando y ya
         aparece el texto) => desliza card 1 -> card 2.
       - Cuando esa sección SALE por abajo (usuario sube y la supera)
         => desliza card 2 -> card 1.
     De la card 3 en adelante: swipe manual del usuario.

     Robustez:
     - Disparo por IntersectionObserver sobre .ent-editorial (no por
       evento scroll): nunca queda atado al scroll vertical continuo.
     - Solo se mueve cuando cambia de estado (1<->2). Idempotente: si
       ya está en el estado objetivo, no hace nada.
     - Cada animación cancela la anterior (cambios rápidos de
       dirección no se encavalgan).
     - Si el usuario hace swipe manual a una card >= 3, se suspende el
       snap automático para no pelear con su exploración.
  -------------------------------------------------------- */
  function initStoriesSnap() {
    var stories = document.querySelector('.ent-stories');
    var marquee = stories && stories.querySelector('.ent-stories__marquee');
    var nextSection = document.querySelector('.ent-editorial');
    if (!stories || !marquee || !nextSection) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;

    var state = 1;           /* 1 = card1, 2 = card2 */
    var userExploring = false;
    var animId = null;

    /* Distancia exacta para alinear la card 2 al inicio (1 card + gap). */
    function card2Distance(){
      var track = marquee.querySelector('.ent-stories__track');
      if (!track) return 0;
      var cards = track.querySelectorAll('.ent-stories__card');
      if (cards.length < 2) return 0;
      var a = cards[0].getBoundingClientRect();
      var b = cards[1].getBoundingClientRect();
      return Math.round(b.left - a.left);
    }

    /* Si el usuario desliza manualmente más allá de la card 2, asumimos
       que está explorando y dejamos de imponer el snap automático. */
    marquee.addEventListener('touchstart', function(){
      /* No suspendemos de inmediato; solo si tras tocar se va lejos. */
      var check = function(){
        var d = card2Distance();
        if (d > 0 && marquee.scrollLeft > d * 1.5){ userExploring = true; }
      };
      setTimeout(check, 350);
    }, { passive: true });

    function ease(p){ return p < 0.5 ? 4*p*p*p : 1 - Math.pow(-2*p+2,3)/2; }

    function animateTo(destX, dur){
      if (animId){ cancelAnimationFrame(animId); animId = null; }
      var startX = marquee.scrollLeft;
      var delta = destX - startX;
      if (Math.abs(delta) < 1){ marquee.scrollLeft = destX; return; }
      var t0 = null;
      function frame(ts){
        if (t0 === null) t0 = ts;
        var p = (ts - t0) / dur;
        if (p > 1) p = 1;
        marquee.scrollLeft = startX + delta * ease(p);
        if (p < 1) animId = requestAnimationFrame(frame); else animId = null;
      }
      animId = requestAnimationFrame(frame);
    }

    function goToCard2(){
      if (userExploring) return;
      if (state === 2) return;
      state = 2;
      var d = card2Distance();
      var ms = marquee.scrollWidth - marquee.clientWidth;
      animateTo(Math.min(d, ms), 700);
    }
    function goToCard1(){
      if (userExploring) return;
      if (state === 1) return;
      state = 1;
      animateTo(0, 700);
    }

    /* Observa la sección "Chocolate Display Box". Cuando es visible
       (aunque sea un poco), estado 2; cuando deja de verse, estado 1.
       rootMargin recorta el fondo del viewport para que el disparo
       ocurra justo cuando el texto entra/sale por la parte baja. */
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) goToCard2();
        else goToCard1();
      });
    }, {
      rootMargin: '0px 0px -20% 0px',
      threshold: 0
    });
    io.observe(nextSection);
  }

  /* --------------------------------------------------------
     UPSELL: mobile auto-scroll
  -------------------------------------------------------- */
  function initUpsellAutoScroll() {
    document.querySelectorAll('.entorno-upsell__track').forEach(function(track) {
      var timer = setInterval(function() {
        if (document.hidden) return;
        var maxSc = track.scrollWidth - track.clientWidth;
        if (maxSc <= 2) { clearInterval(timer); return; }
        if (track.scrollLeft >= maxSc - 5) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          var cardEl = track.querySelector('.entorno-upsell__card');
          var step = cardEl ? cardEl.offsetWidth + 14 : Math.round(track.clientWidth * 0.82);
          track.scrollBy({ left: step, behavior: 'smooth' });
        }
      }, 2300);
      track.addEventListener('touchstart', function() { clearInterval(timer); }, { passive: true, once: true });
    });
  }

  /* --------------------------------------------------------
     PDP STICKY ATC BAR
  -------------------------------------------------------- */
  function initStickyATC() {
    var atcBtn = document.querySelector('.ent-pdp__atc');
    var priceEl = document.querySelector('[id^="ent-price-"]');
    var pdpEl = document.querySelector('.ent-pdp');
    if (!atcBtn || !pdpEl) return;
    var bar = document.createElement('div');
    bar.className = 'ent-pdp__sticky-bar';
    var titleText = document.querySelector('.ent-pdp__title') ? document.querySelector('.ent-pdp__title').textContent.trim() : '';
    var priceText = priceEl ? priceEl.textContent.trim() : '';
    bar.innerHTML =
      '<span class="ent-pdp__sticky-title">' + titleText + '</span>' +
      '<span class="ent-pdp__sticky-price">' + priceText + '</span>' +
      '<button type="button" class="ent-pdp__sticky-atc">Agregar</button>';
    document.body.appendChild(bar);
    var stickyATC = bar.querySelector('.ent-pdp__sticky-atc');
    var stickyPrice = bar.querySelector('.ent-pdp__sticky-price');
    function onScroll() {
      var rect = atcBtn.getBoundingClientRect();
      if (rect.bottom < 0) { bar.classList.add('is-visible'); }
      else { bar.classList.remove('is-visible'); }
      if (priceEl && stickyPrice) stickyPrice.textContent = priceEl.textContent.trim();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    if (stickyATC) stickyATC.addEventListener('click', function() { atcBtn.click(); });
  }

  /* --------------------------------------------------------
     CART DRAWER TRIGGER after AJAX add-to-cart
  -------------------------------------------------------- */
  function initCartDrawerTrigger() {
    var countEls = document.querySelectorAll('.hdr-cart-count-numb, [data-cart-item-count]');
    if (!countEls.length) return;
    var lastCount = parseInt(countEls[0].textContent) || 0;
    var observer = new MutationObserver(function() {
      var newCount = parseInt(countEls[0].textContent) || 0;
      if (newCount > lastCount) {
        lastCount = newCount;
        var opener = document.querySelector('[aria-controls="CartDrawer"]') ||
                     document.querySelector('.cart-icon--bubble');
        if (opener) setTimeout(function() { opener.click(); }, 200);
      }
    });
    countEls.forEach(function(el) {
      observer.observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  /* ── Init ── */
  function init() {
    if (!isMobile) return;
    initStoriesSnap();
    initUpsellAutoScroll();
    if (document.querySelector('.ent-pdp')) {
      initStickyATC();
      initCartDrawerTrigger();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
